import React from "react";
import { Modal } from "react-bootstrap";
import styled from "styled-components";
import BarChart from "instructor/components/dashboard-bar-chart";
import { Loader } from "react-loaders";

const EngagementModal = styled(Modal)`
  background: rgba(0, 0, 0, 0.5) !important;

  .modal-dialog {
    width: 1077px !important;

    .modal-content {
      padding: 20px 20px 120px !important;
      border-radius: 4px !important;
      box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25) !important;
      border: none !important;
    }
  }
`;

const ModalHeader = styled(Modal.Header)`
  padding: 0 0 0 20px !important;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  > div {
    width: 100%;
  }
`;

const ModalBody = styled(Modal.Body)`
  padding: 0 0 0 10px !important;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  .loader {
    width: 100%;

    .loader-inner {
      div {
        margin-left: auto;
        margin-right: auto;
        margin-top: 100px;
        border-color: #2a4169;
      }
    }
  }
`;

const Title = styled.div`
  font-family: Lato;
  font-size: 36px;
  line-height: 43px;
  color: #4f4f4f;
`;

const SubTitle = styled.div`
  font-family: Lato;
  font-weight: bold;
  font-size: 40px;
  line-height: 48px;
  color: #bdbdbd;
  margin-top: 10px;
`;

const Rating = styled.div`
  font-family: Lato;
  font-weight: bold;
  font-size: 150px;
  line-height: 180px;
  color: #4f4f4f;
  text-transform: uppercase;
  margin-top: 100px;

  ${p =>
    p.reduceSize &&
    `
    font-size: 100px;
  `}
`;

const Description = styled.div`
  font-family: Lato;
  font-size: 14px;
  line-height: 17px;
  color: #000;
  padding-right: 110px;
  padding-left: 10px;
`;

const BarChartWrapper = styled.div`
  flex: 0 0 555px;
`;

const ChartTitle = styled.div`
  font-family: Lato;
  font-size: 20px;
  line-height: 24px;
  color: #000;

  ${p =>
    p.marginTop &&
    `
    margin-top: ${p.marginTop};
  `}
`;

const Chart = styled.div`
  display: flex;
  align-items: center;
  margin-top: 5px;

  .recharts-label-list {
    text {
      font-family: Lato;
      font-weight: bold;
      font-size: 30px;
      line-height: 30px;
      color: #000;
    }
  }
`;

const EngagementPopup = ({
  show,
  onHide,
  username = "",
  loading = false,
  caseStudy = 0,
  customerAnalysis = 0,
  teamReports = 0,
  rate = "",
  rateDescription = ""
}) => (
  <EngagementModal
    show={show}
    onHide={onHide}
    backdropClassName="transparent-backdrop"
  >
    <ModalHeader>
      {loading === false && (
        <div>
          <Title>{username}</Title>
          <SubTitle>Engagement</SubTitle>
        </div>
      )}
    </ModalHeader>
    <ModalBody>
      {loading === true && <Loader type="ball-scale-ripple" active />}
      {loading === false && (
        <div>
          <Rating reduceSize={rate.length > 4 ? true : false}>{rate}</Rating>
          <Description>
            This student reviewed {rateDescription} of the content that's needed
            to be reviewed this round.
            <br />
            <br />
            <b>Note:</b> The 3 reports to the right are not weighted equally.
            For example in Round 1, the Case Study is heavily weighted and the
            Team Reports have the least weight, but as the rounds progress, the
            weight shifts.
          </Description>
        </div>
      )}
      {loading === false && (
        <BarChartWrapper>
          <ChartTitle marginTop="5px">Case Study</ChartTitle>
          <Chart>
            <BarChart
              height={68}
              color="#52c5cd"
              value={caseStudy}
              labelOffset={40}
              animation={false}
              rightMargin={85}
              labelSuffix="%"
            />
          </Chart>
          <ChartTitle marginTop="70px">
            Customer
            <br />
            Analysis
          </ChartTitle>
          <Chart>
            <BarChart
              height={68}
              color="#00b0ff"
              value={customerAnalysis}
              labelOffset={40}
              animation={false}
              rightMargin={85}
              labelSuffix="%"
            />
          </Chart>
          <ChartTitle marginTop="70px">
            Team
            <br />
            Reports
          </ChartTitle>
          <Chart>
            <BarChart
              height={68}
              color="#f9c151"
              value={teamReports}
              labelOffset={40}
              animation={false}
              rightMargin={85}
              labelSuffix="%"
            />
          </Chart>
        </BarChartWrapper>
      )}
    </ModalBody>
  </EngagementModal>
);

export default EngagementPopup;



// WEBPACK FOOTER //
// ./src/instructor/components/engagement-popup.js